export type BorderRadiusKeys = keyof typeof borderRadius

export const borderRadius = {
  small: '0.4rem',
  medium: '0.8rem',
  large: '1rem',
  xLarge: '2.4rem',
  rounded: '9999px',
}
